import { en } from './en';
import { es } from './es';

export const locales = {
    en: en,
    es: es
};